module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAMNJREFUSA1jZEADnZ2dW////++FJkwWl5GRcVt5ebk3smYmZA6ITS3LcJmFYSG6A6jNZ8FnYEVFBSM+eVxyHR0d/3HJ0d2HoxbiigqyxUeDlOygw6VxNEhxhQzZ4qNBSnbQ4dI4GqS4QoZscbwVML6KlFwbB38cAlti24FYFoq3k+pTcnyYBmz6PQFhoGVp9LCQVDtQ1ONNNCgqEZxZwMYyzGezEMLEsUi2ENhQ9gQa/Zg44zFVYcQhqHmOqYxska3oOgEs4CVDEF5uWgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/account.png
// module id = 284
// module chunks = 1